import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
import option from "@/const/user/info";
import { getUserInfo, updateInfo, updatePassword } from "@/api/system/user";
import md5 from 'js-md5';
export default {
  data: function data() {
    return {
      type: "info",
      option: option,
      form: {}
    };
  },
  created: function created() {
    this.handleWitch();
  },
  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      if (this.type === "info") {
        updateInfo(this.form).then(function (res) {
          if (res.data.success) {
            _this.$message({
              type: "success",
              message: "修改信息成功!"
            });
          } else {
            _this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      } else {
        updatePassword(md5(this.form.oldPassword), md5(this.form.newPassword), md5(this.form.newPassword1)).then(function (res) {
          if (res.data.success) {
            _this.$message({
              type: "success",
              message: "修改密码成功!"
            });
          } else {
            _this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      }
    },
    handleWitch: function handleWitch() {
      var _this2 = this;

      if (this.type === "info") {
        getUserInfo().then(function (res) {
          var user = res.data.data;
          _this2.form = {
            id: user.id,
            avatar: user.avatar,
            name: user.name,
            realName: user.realName,
            phone: user.phone,
            email: user.email
          };
        });
      }
    },
    handleChange: function handleChange(item) {
      this.type = item.prop;
      this.handleWitch();
    }
  }
};